import { PERMISSIONS } from "@/constants/permissions";
import { useHasPermission } from "./usePermissions";

export function useIsOrgAdmin() {
  return useHasPermission(PERMISSIONS.ORG_ADMIN.ALL);
}
